import type * as appointments from '@seen/core/models/appointments/index'
import type { Participant } from '@seen/core/models/patients/participant'
import { create } from 'zustand'
import { combine, devtools, persist } from 'zustand/middleware'

export const useModalStore = create(
  devtools(
    persist(
      combine(
        {
          checkInOpen: false,
          checkOutOpen: false,
          participant: null as Participant | null,
          appointment: null as appointments.ExtendedAppointment | null,
        },
        (set) => ({
          setCheckInOpen: (open: boolean) => set({ checkInOpen: open }),
          setCheckOutOpen: (open: boolean) => set({ checkOutOpen: open }),
          setParticipant: (participant: Participant | null) =>
            set({ participant }),
          setAppointment: (
            appointment: appointments.ExtendedAppointment | null
          ) => set({ appointment }),
        })
      ),
      {
        name: 'modal-store',
      }
    )
  )
)
